/**
 * Calendar layout constants used across all big calendar components
 */
export const CALENDAR_CONSTANTS = {
  ROW_HEIGHT: 57,
  MINIMUM_ROWS: 10,
  HEADER_HEIGHT: 48,
  TITLE_COLUMN_WIDTH: 200,
  DAY_COLUMN_WIDTH: 72,
} as const;

export type CalendarConstants = typeof CALENDAR_CONSTANTS;
